import { useState, useEffect, useMemo, useLayoutEffect, useRef } from 'react';
import MotionLayout from '../../general/framer-motion/MotionLayout';
import {useLocalStorageListener,getUserDetail } from '../../../hooks/handleUserLocalStorage';
import { FilterProvider } from '../../../context/FilterContext';
import FilterInputBuilder from '../../filterInputBuilder/userFilter';
import CloseButton from '../../layouts/CloseButton';
import OpenButton from '../../layouts/OpenButton';
import { siderWidth } from '../../../constants/layout';
import { contentPadding } from '../../layouts/layoutHelper';
import { Form, Input, Button } from 'antd';



const Index = ({
    page,
    openNewTab = false,
    isPayment = false,
}:any) => {
    const iframeName = 'tool-iframe';
    const formRef = useRef(null);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [iframeUrl, setIframeUrl] = useState('');
    const [hasInteracted, setHasInteracted] = useState(false);
    const [amount, setAmount] = useState('');
    const [selectedAccountTitle, setSelectedAccountTitle] = useState('');

    useEffect(() => {

    }, []);

    useEffect(() => {
      
        // Update iframe URL when account or page changes
        if (selectedAccount && page) {
            const url = page.replace('[accountid]', selectedAccount);
            setIframeUrl(url);
        }
    }, [selectedAccount, page]);

    const handleSidebarToggle = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    const handleNewTabSubmit = () => {
        if (!amount) return;
        const url = page.replace('[accountid]', selectedAccount);
        window.open(`${url}?amount=${amount}`, '_blank');
    };

    const filterColumns = [
        {
            type: "selectUser",
            singleMode: true,
        },
    ];


    return (
        <MotionLayout>
            <FilterProvider>
                <div className={`page-layout ${isSidebarCollapsed ? 'collapsed' : ''}`}>
                    <div className="side-bar" style={{
                        width: isSidebarCollapsed ? '0' : siderWidth
                    }}>
                        <CloseButton
                            handleClick={handleSidebarToggle}
                        />
                        <div className='content' style={{width:siderWidth}}>
                            <div className='pt-3'></div>
                            <FilterInputBuilder
                                searchText='Select'
                                columns={filterColumns}
                                initSearchWhenReceived={[`accounts[]`]}
                                onSearchSubmit={(inputs:any)=>{
                                    setHasInteracted(true);
                                    let accounts = inputs['accounts[]'] || [];
                                    let details = inputs['accounts_details[]'] || [];
                                    if (accounts.length > 0) {
                                        setSelectedAccount(accounts[0]);
                                        setSelectedAccountTitle(details[0]?.title || '');
                                    } else {
                                        setSelectedAccount('');
                                        setSelectedAccountTitle('');
                                    }
                                }}
                            />
                        </div>

                    </div>
                    <div className="main-content" style={{
                        marginLeft: isSidebarCollapsed ? '0px' : siderWidth,
                        paddingLeft: isSidebarCollapsed ? '0px' : '20px',
                    }}>
                        <OpenButton
                            isSidebarCollapsed={isSidebarCollapsed}
                            handleClick={handleSidebarToggle}
                        />
                        <div className={contentPadding(isSidebarCollapsed)}>

                            {openNewTab && isPayment ? (
                                selectedAccount ? (
                                    <div className="">
                                        <h2 className='pt-3 pb-4 main-title'>Online Payment</h2>
                                        <Form
                                        layout='vertical'
                                        style={{ maxWidth: 260 }}>
                                            <div className="pb-3"><b>Account No:</b> {selectedAccountTitle}</div>
                                            <Form.Item
                                                label="Amount"
                                                required
                                                validateStatus={amount && parseFloat(amount) < 1 ? 'error' : ''}
                                                help={amount && parseFloat(amount) < 1 ? 'Minimum amount is 1.00' : ''}
                                            >
                                                <Input
                                                    className="custom"
                                                    value={amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    placeholder="Enter amount"
                                                    onKeyDown={(e) => { if (!/[\d.]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') e.preventDefault(); }}
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button
                                                    className="btn-primary-custom btn-md"
                                                    disabled={!amount || parseFloat(amount) < 1}
                                                    onClick={handleNewTabSubmit}
                                                >
                                                    Submit
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                ) : hasInteracted ? (
                                    <div className='text-center p-5'>
                                        Please select an account to view the content
                                    </div>
                                ) : null
                            ) : (
                                iframeUrl && selectedAccount ? (
                                    <iframe
                                        name={iframeName}
                                        src={iframeUrl}
                                        style={{
                                            width: '100%',
                                            height: 'calc(100vh - 100px)',
                                            border: 'none'
                                        }}
                                    />
                                ) : hasInteracted ? (
                                    <div className='text-center p-5'>
                                        Please select an account to view the content
                                    </div>
                                ) : null
                            )}
                        </div>
                    </div>
                </div>
            </FilterProvider>
        </MotionLayout>
    );
};

export default Index;




  
